import { makeApiCall } from "../makeApiCall";
import { AdminService_NEW_URL, AdminService_URL } from "../Url";

export const scannerActions = {
  FETCH_BOX_SCAN_ORDER_DATA_SUCCESS: "FETCH_BOX_SCAN_ORDER_DATA_SUCCESS",
  FETCH_BOX_SCAN_ORDER_DATA_FAILURE: "FETCH_BOX_SCAN_ORDER_DATA_FAILURE",
  FETCH_ORDER_SCAN_ORDER_DATA_SUCCESS: "FETCH_ORDER_SCAN_ORDER_DATA_SUCCESS",
  FETCH_ORDER_SCAN_ORDER_DATA_FAILURE: "FETCH_ORDER_SCAN_ORDER_DATA_FAILURE",
};

////////////////////////////////////////////////
//? Assign box after scanning
////////////////////////////////////////////////

export function getBoxIDScanSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: scannerActions.FETCH_BOX_SCAN_ORDER_DATA_SUCCESS,
      payload: props,
    });
  };
}

export function getBoxIDScanError(error) {
  return {
    type: scannerActions.FETCH_BOX_SCAN_ORDER_DATA_FAILURE,
    payload: error,
  };
}

export function setBoxIDScanThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const getUrl = `${AdminService_URL}/addOrUpdateBoxNumberForOrder?orderId=${props.orderId}&boxNumber=${props.boxNumber}&isSetBox=${props.isSetBox}`;
  return makeApiCall(
    getUrl,
    getBoxIDScanSuccess,
    getBoxIDScanError,
    "POST",
    null,
    reqHeader,
    props.history
  );
}

////////////////////////////////////////////////
//? Assign order ID after scanning
////////////////////////////////////////////////

export function getOrderIDScanSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: scannerActions.FETCH_ORDER_SCAN_ORDER_DATA_SUCCESS,
      payload: props,
    });
  };
}

export function getOrderIDScanError(error) {
  return {
    type: scannerActions.FETCH_ORDER_SCAN_ORDER_DATA_FAILURE,
    payload: error,
  };
}

export function getOrderIDScanThunk(props) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const getUrl = `${AdminService_NEW_URL}/getOrderForBoxNumber?boxNumber=${props.boxNumber}`;
  return makeApiCall(
    getUrl,
    getOrderIDScanSuccess,
    getOrderIDScanError,
    "GET",
    null,
    reqHeader,
    props.history
  );
}
